import React from "react";
import { useLocation } from "react-router-dom";
import DOMPurify from "dompurify";

export default function AboutUsDetail() {
  const location = useLocation();
  const page = location.state?.content?.data?.page;

  if (!page) return <div>No content found.</div>;

  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">{page.title}</h1>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content || "") }} />
    </div>
  );
}